import { ApiClient } from '../lib/api';
import { ReferralSource, ReferralSourceSchema, WebsiteIntakeForm, WebsiteIntakeFormSchema } from '../models';

const mockApiKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiYWRtaW4iOnRydWUsImlhdCI6MTUxNjIzOTAyMn0.KMUFsIDTnFmyG3nMiGM6H9FNFUROf3wh7SmqJp-QV30";

export class WebsiteIntakeFormService {
    private api: ApiClient;

    constructor(baseURL: string, stage: string) {
        this.api = new ApiClient(`${baseURL}/${stage}/website-form-service-${stage}`, stage);
    }

    async getReferralSources(): Promise<ReferralSource[]> {
        const referralSources = await this.api.request(
            { method: 'GET', url: '/referral-sources',
                headers: {
                    'Authorization': `Bearer ${mockApiKey}`
                }
             },
            ReferralSourceSchema.array()
        );
        return referralSources.map(referralSource => this.setDefaults(referralSource));
    }

    async submitWebsiteIntakeForm(WebsiteIntakeForm: WebsiteIntakeForm): Promise<WebsiteIntakeForm> {
        const result = await this.api.request(
            { method: 'POST', url: '/submit-form', data: WebsiteIntakeForm,
                headers: {
                    'Authorization': `Bearer ${mockApiKey}`
                }
             },
            WebsiteIntakeFormSchema
        );
        return this.setWebsiteIntakeFormDefaults(result);
    }

    private setDefaults(data: unknown): ReferralSource {
        return ReferralSourceSchema.parse(data);
    }

    private setWebsiteIntakeFormDefaults(data: unknown): WebsiteIntakeForm {
        return WebsiteIntakeFormSchema.parse(data);
    }
} 